var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.formSubmitted($event)
            },
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Transaction Type",
                        "label-for": "trxType",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          id: "trxType",
                          name: "trxType",
                          options: _vm.types,
                          disabled: "",
                        },
                        model: {
                          value: _vm.transaction.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.transaction, "type", $$v)
                          },
                          expression: "transaction.type",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Transaction Date",
                        "label-for": "trxDate",
                      },
                    },
                    [
                      _c("b-form-datepicker", {
                        staticClass: "mb-1",
                        attrs: { id: "trxDate", disabled: "" },
                        model: {
                          value: _vm.transaction.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.transaction, "date", $$v)
                          },
                          expression: "transaction.date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "From Warehouse",
                        "label-for": "fromWarehouse",
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          attrs: {
                            id: "fromWarehouse",
                            name: "fromWarehouse",
                            options: _vm.warehouses,
                            "value-field": "id",
                            "text-field": "name",
                            disabled: "",
                          },
                          model: {
                            value: _vm.transaction.fromWarehouse,
                            callback: function ($$v) {
                              _vm.$set(_vm.transaction, "fromWarehouse", $$v)
                            },
                            expression: "transaction.fromWarehouse",
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("None"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "To Warehouse",
                        "label-for": "toWarehouse",
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          attrs: {
                            id: "toWarehouse",
                            name: "toWarehouse",
                            options: _vm.warehouses,
                            "value-field": "id",
                            "text-field": "name",
                            disabled: "",
                          },
                          model: {
                            value: _vm.transaction.toWarehouse,
                            callback: function ($$v) {
                              _vm.$set(_vm.transaction, "toWarehouse", $$v)
                            },
                            expression: "transaction.toWarehouse",
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("None"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "mb-2", attrs: { cols: "12" } },
                [
                  _c("label", { attrs: { for: "trxRef" } }, [
                    _vm._v("Transaction Reference"),
                  ]),
                  _c("b-form-textarea", {
                    attrs: {
                      id: "trxRef",
                      name: "trxRef",
                      rows: "3",
                      disabled: "",
                    },
                    model: {
                      value: _vm.transaction.refNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.transaction, "refNo", $$v)
                      },
                      expression: "transaction.refNo",
                    },
                  }),
                ],
                1
              ),
              _c("b-col", { staticClass: "mb-2", attrs: { cols: "12" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center mb-1" },
                  [
                    _vm.loading ||
                    _vm.productLoading ||
                    _vm.materialLoading ||
                    _vm.uomLoading ||
                    _vm.warehouseLoading
                      ? _c("b-spinner", {
                          staticStyle: { width: "3rem", height: "3rem" },
                          attrs: {
                            variant: "success",
                            label: "Spinning",
                            block: "",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-form",
        {
          ref: "form",
          staticClass: "repeater-form",
          style: { height: _vm.trHeight },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.addLine($event)
            },
          },
        },
        [
          _c("b-row", [_c("b-col", { attrs: { cols: "12" } }, [_c("hr")])], 1),
          _vm._l(_vm.transaction.inventoryTransactionLine, function (item) {
            return _c(
              "b-row",
              {
                key: item.serial,
                ref: "row",
                refInFor: true,
                attrs: { id: item.serial },
              },
              [
                _c(
                  "b-col",
                  { attrs: { md: "3" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: "Product / Raw Material",
                          "label-for": "itemId",
                        },
                      },
                      [
                        _c("b-form-select", {
                          attrs: {
                            id: "itemId",
                            name: "itemId",
                            options: _vm.items,
                            "value-field": "id",
                            "text-field": "name",
                            disabled: "",
                          },
                          model: {
                            value: item.itemId,
                            callback: function ($$v) {
                              _vm.$set(item, "itemId", $$v)
                            },
                            expression: "item.itemId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  { attrs: { md: "2" } },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Qty", "label-for": "itemQty" } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "itemQty",
                            name: "itemQty",
                            type: "number",
                            min: "1",
                            max: "100",
                            placeholder: "",
                            disabled: "",
                          },
                          model: {
                            value: item.qty,
                            callback: function ($$v) {
                              _vm.$set(item, "qty", $$v)
                            },
                            expression: "item.qty",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }